import { HttpApiEndpoint, HttpApiGroup } from "@effect/platform";
import { HealthRequest, HealthResponse } from "../models/health";

export const HealthGroup = HttpApiGroup.make("health")
  .add(HttpApiEndpoint.get("getHealth", "/health").addSuccess(HealthResponse))
  .add(
    HttpApiEndpoint.post("postHealth", "/health")
      .addSuccess(HealthResponse)
      .setPayload(HealthRequest),
  );
